import { observable, action, runInAction } from 'mobx'

import { getFacultyNewsStories } from 'transport/huskytales'

class HuskyTalesStore {
  @observable facultyNewsStories = []

  componentWillUnMount () {
    this.clearFacultyNewsStories()
  }

  @action async fetchFacultyNewsStories (netid) {
    try {
      const stories = await getFacultyNewsStories(netid)
      runInAction(() => {
        this.facultyNewsStories = stories
      })
    } catch (error) {
      runInAction(() => {
        this.facultyNewsStories = []
      })
    }
  }

  @action clearFacultyNewsStories () {
    this.facultyNewsStories.clear()
  }
}

const singleton = new HuskyTalesStore()
export default singleton



// WEBPACK FOOTER //
// ./resources/assets/js/stores/HuskyTalesStore.js